/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { CrmAlertComponent } from 'src/app/components/fields';
import { Report } from 'src/app/model';
import { ReportProvider } from 'src/app/providers';
import { SystemType } from 'src/app/model/enums/system.type';
import { ModeService,LogService } from 'src/app/services';

@Component({
  selector: 'report-merge-modal',
  templateUrl: './report-merge.modal.html',
  styleUrls: ['./report-merge.modal.scss']
})
export class ReportMergeModal implements OnInit, OnDestroy {
  @ViewChild('alert') alert: CrmAlertComponent;
  subject: Subject<Report>;
  subscription: any;
  selectedReport: Report;
  report: Report;

  currentMode: SystemType;
  modeSub: any;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    public reportProvider: ReportProvider,
    private modeService: ModeService,
    private logService:LogService
  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc') {
        this.onCancel();
      }
    });

    this.modeSub = this.modeService.mode$.subscribe(mode => this.currentMode = mode);
  }

  ngOnDestroy(): void {
    if(this.modeSub)
      this.modeSub.unsubscribe();
  }

  onSelected(value: any): void {
    this.selectedReport = value != null ? value.VALUE : null;
  }

  onConfirm(): void {
    this.alert.hide();
    this.reportProvider.merge(this.report.ID, this.selectedReport.ID, this.currentMode)
      .subscribe(data => {
        if (data.success) {
          this.bsModalRef.hide();
          this.subject.next(this.selectedReport);
          this.subject.complete();
        }
        else {
          this.alert.show(data.error);
        }
      }, err => {
        this.alert.show(err);
        this.logService.error(err);
      });
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(null);
    this.subject.complete();
  }
}
